import { termTranslations } from "./TermTranslations.slice";

export const termTranslationsActions = { ...termTranslations.actions };
